/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable, NgZone } from '@angular/core';
import { MatLegacySnackBar, MatLegacySnackBarConfig } from '@angular/material/legacy-snack-bar';
import { SnackbarType } from '../models/snackbar';
import { SnackbarComponent } from './snackbar.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/legacy-snack-bar";
const validTypes = ['success', 'info', 'warning', 'error'];
const defaultType = validTypes[0];
const infoTypes = ['', 'log', 'default', 'blue'];
const successTypes = ['green', 'ok', 'good'];
const warningTypes = ['warn', 'yellow'];
const errorTypes = ['danger', 'fatal', 'red', 'bad'];
/**
 * Service to create/dismiss the snackbar
 *
 * @export
 * @class SnackBar
 */
export class SnackBar {
    /**
     * Creates an instance of SnackBar.
     *
     * @param {MatLegacySnackBar} snackBar
     * @memberof SnackBar
     */
    constructor(snackBar, zone) {
        this.snackBar = snackBar;
        this.zone = zone;
        this.defaultDuration = {
            info: 5000,
            success: 2000,
            warning: 10000,
            error: -1
        };
        // this.addDefaultContainer();
        this.defaultConfig = new MatLegacySnackBarConfig();
        this.defaultConfig = {
            horizontalPosition: 'right',
            duration: 10000,
            verticalPosition: 'top'
        };
    }
    /**
     * Returns the alert type
     *
     * @private
     * @param {string} type
     * @returns {string}
     * @memberof SnackBar
     */
    getAlertType(type) {
        type = type || defaultType;
        type = type.toLowerCase();
        if (validTypes.indexOf(type) !== -1) {
            return type;
        }
        else if (infoTypes.indexOf(type) !== -1) {
            return 'info';
        }
        else if (successTypes.indexOf(type) !== -1) {
            return 'success';
        }
        else if (warningTypes.indexOf(type) !== -1) {
            return 'warning';
        }
        else if (errorTypes.indexOf(type) !== -1) {
            return 'error';
        }
        return defaultType;
    }
    /**
     * Dismisses/Closes the notification if currently opened
     *
     * @memberof SnackBar
     */
    dismiss() {
        this.snackBar.dismiss();
    }
    /**
     * Uses the Material Snackbar service to create a default/custom notification
     *
     * @param {SnackbarData} snackbarData
     * @returns {MatLegacySnackBarRef<SnackBarComponentType>}
     * @memberof SnackBar
     */
    addSnackBar(snackbarData) {
        let newConfig = snackbarData.configs;
        if (!newConfig) {
            newConfig = this.defaultConfig;
        }
        let durationMs = snackbarData.durationMs;
        let type = validTypes[snackbarData.type];
        if (type) {
            type = this.getAlertType(type);
            if (isNaN(durationMs) || durationMs < -1) {
                durationMs = this.defaultDuration[type];
            }
        }
        durationMs = durationMs ? durationMs : this.defaultConfig.duration;
        snackbarData.inputs = {
            ...snackbarData.inputs,
            type: snackbarData.componentClass ? SnackbarType.CUSTOM : SnackbarType.DEFAULT
        };
        newConfig = { ...newConfig, data: snackbarData.inputs, duration: durationMs, panelClass: type };
        const compClass = snackbarData.componentClass ? snackbarData.componentClass : SnackbarComponent;
        return this.zone.run(() => this.snackBar.openFromComponent(compClass, newConfig));
    }
    static { this.ɵfac = function SnackBar_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SnackBar)(i0.ɵɵinject(i1.MatLegacySnackBar), i0.ɵɵinject(i0.NgZone)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SnackBar, factory: SnackBar.ɵfac }); }
}
//# sourceMappingURL=snackbar.service.js.map